import { useSelector } from 'react-redux';
import { store } from './ReduxWrapper';

export default function getStateField(fieldName, state = store.getState()) {
  const field = state.person.stateFields?.[fieldName];

  if (!field) {
    return undefined;
  }

  if (field.fieldType && field.fieldType.fieldFormat === 'Boolean') {
    return field.bool_value;
  }

  return field.text;
}

export function getStateFieldFootnotes(fieldName, state = store.getState()) {
  const field = state.person.stateFields?.[fieldName];

  if (!field) {
    return undefined;
  }

  return field.footnotes;
}

export function useStateField(fieldName) {
  return useSelector((state) => getStateField(fieldName, state));
}

export function getStateCode(state = store.getState()) {
  return state.person.state;
}

export function useStateCode() {
  return useSelector((state) => getStateCode(state));
}

export function getStateName(state = store.getState()) {
  return state.person.stateName;
}

export function useStateName() {
  return useSelector((state) => getStateName(state));
}
